import { createRouter, createWebHistory } from "vue-router";
import { useLoggedInUserStore } from "./store/LoggedInUserStore";
import MsalService from "@/service/MsalService.js";
import { usePharmacyStore } from "@/store/PharmacyStore";
import { storeToRefs } from "pinia";
import { PERMISSIONS } from "@/Constants.js";

const router = createRouter({
  history: createWebHistory(),
  routes: [
    {
      path: "/search",
      name: "search",
      component: () => import("@/pages/PharmacySearch.vue"),
    },
    {
      path: "/bep",
      name: "bep",
      component: () => import("@/pages/IaBackendManagement.vue"),
      beforeEnter: (to, from, next) => {
        const pharmacyStore = usePharmacyStore();
        const { getPharmacy } = storeToRefs(pharmacyStore);

        if (!getPharmacy.value) {
          // redirect to /search if no pharmacy is selected
          next("/search");
        } else {
          next();
        }
      },
    },
    {
      path: "/not-authorized",
      name: "not-authorized",
      component: () => import("@/pages/NotAuthorized.vue"),
    },
    {
      path: "/:catchAll(.*)",
      redirect: {
        name: "search",
      },
    },
  ],
  scrollBehavior() {
    return { left: 0, top: 0 };
  },
});

router.beforeEach(async (to, from, next) => {
  const loggedInUserStore = useLoggedInUserStore();

  if (!loggedInUserStore.getCurrentUser?.isUserLoggedIn) {
    const msalService = new MsalService();
    await msalService.msalCallReducer(msalService.reducerActions.login);
  }

  if (to.hash?.includes("state")) {
    router.replace({ path: to.path, query: to.query });
  }

  // Check if user has access to the partner-portal
  if (to.fullPath !== "/not-authorized") {
    if (!loggedInUserStore.hasPermission(PERMISSIONS.PartnerPortal)) {
      next({ name: "not-authorized" });
      return;
    }
  }

  // ! Check if user has permission to access the page
  if (
    to.meta?.permission &&
    !loggedInUserStore.hasPermission(to.meta?.permission)
  ) {
    next({ name: to.meta?.redirect ?? "search" });
  } else {
    next();
  }
});

export default router;
